import React, { useState, useEffect } from 'react';
import './App.css';

function App() {
  const [loanAmount, setLoanAmount] = useState('');
  const [btcAmount, setBtcAmount] = useState('');
  const [ltvMarginCall, setLtvMarginCall] = useState('70');
  const [ltvLiquidation, setLtvLiquidation] = useState('80');
  const [btcPriceMarginCall, setBtcPriceMarginCall] = useState('');
  const [btcPriceLiquidation, setBtcPriceLiquidation] = useState('');

  const formatNumber = (num) => {
    // Format number with thousands separators using apostrophe
    return num.toLocaleString('en-CH', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
  };

  const calculateBtcPrice = (loanAmount, btcAmount, ltv) => {
    if (!loanAmount || !btcAmount) return null;
    const loan = parseFloat(loanAmount);
    const btc = parseFloat(btcAmount);
    const ltvValue = parseFloat(ltv) / 100;
    return loan / (ltvValue * btc);
  };

  useEffect(() => {
    const marginCallPrice = calculateBtcPrice(loanAmount, btcAmount, ltvMarginCall);
    const liquidationPrice = calculateBtcPrice(loanAmount, btcAmount, ltvLiquidation);
    
    setBtcPriceMarginCall(marginCallPrice !== null ? formatNumber(marginCallPrice) : '');
    setBtcPriceLiquidation(liquidationPrice !== null ? formatNumber(liquidationPrice) : '');
  }, [loanAmount, btcAmount, ltvMarginCall, ltvLiquidation]);

  return (
    <div className="container">
      <div className="card">
        <h1 className="card-title">Bitcoin Loan LTV Calculator</h1>
        
        <div className="input-groups">
          {/* Loan Amount Input */}
          <div className="input-group">
            <label className="input-label">Loan Amount</label>
            <input
              type="text"
              inputMode="decimal"
              value={loanAmount}
              onChange={(e) => setLoanAmount(e.target.value)}
              className="input-field no-spinner"
              placeholder="Enter loan amount"
            />
          </div>

          {/* BTC Collateral Input */}
          <div className="input-group">
            <label className="input-label">
              Bitcoin Collateral (BTC)
            </label>
            <input
              type="text"
              inputMode="decimal"
              value={btcAmount}
              onChange={(e) => setBtcAmount(e.target.value)}
              className="input-field no-spinner"
              placeholder="Enter BTC amount"
            />
          </div>

          {/* LTV Inputs */}
          <div className="input-group grid grid-cols-2 gap-4">
            <div className="input-group">
              <label className="input-label">LTV Margin Call (%)</label>
              <input
                type="number"
                value={ltvMarginCall}
                onChange={(e) => setLtvMarginCall(e.target.value)}
                className="input-field"
                min="0"
                max="100"
                step="0.1"
              />
            </div>
            <div className="input-group">
              <label className="input-label">LTV Liquidation (%)</label>
              <input
                type="number"
                value={ltvLiquidation}
                onChange={(e) => setLtvLiquidation(e.target.value)}
                className="input-field"
                min="0"
                max="100"
                step="0.1"
              />
            </div>
          </div>

          {/* Results */}
          <div className="results">
            <h2 className="results-title">Results</h2>
            <div className="results-grid">
              <div className="result-item">
                <p className="result-label">Bitcoin Price at Margin Call</p>
                <p className="result-value margin-call">
                  {btcPriceMarginCall}
                </p>
              </div>
              <div className="result-item">
                <p className="result-label">Bitcoin Price at Liquidation</p>
                <p className="result-value liquidation">
                  {btcPriceLiquidation}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default App;